import {AString} from '@mintdata/mint-kit/api/values/AString';
import {AStringEnum} from '@mintdata/mint-kit/api/values/AStringEnum';

export class WrapType extends AStringEnum
{
    public constructor(value:AString)
    {
        super(value, WrapType._types);
    }

    public toString():string
    {
        return this.value ? this.value.toString() : null;
    }

    public static NO_WRAP = new AString('No Wrap');
    public static START = new AString('Start');
    public static END = new AString('End');
    public static CENTER = new AString('Center');
    public static SPACE_BETWEEN = new AString('Space Between');
    public static SPACE_AROUND = new AString('Space Around');
    public static SPACE_EVENLY = new AString('Space Evenly');
    public static START_REVERSED = new AString('Start Reversed');
    public static END_REVERSED = new AString('End Reversed');
    public static CENTER_REVERSED = new AString('Center Reversed');
    public static SPACE_BETWEEN_REVERSED = new AString('Space Between Reversed');
    public static SPACE_AROUND_REVERSED = new AString('Space Around Reversed');
    public static SPACE_EVENLY_REVERSED = new AString('Space Evenly Reversed');

    private static _types:Array<AString> = [
        WrapType.NO_WRAP,
        WrapType.START,
        WrapType.END,
        WrapType.CENTER,
        WrapType.SPACE_BETWEEN,
        WrapType.SPACE_AROUND,
        WrapType.SPACE_EVENLY,
        WrapType.START_REVERSED,
        WrapType.END_REVERSED,
        WrapType.CENTER_REVERSED,
        WrapType.SPACE_BETWEEN_REVERSED,
        WrapType.SPACE_AROUND_REVERSED,
        WrapType.SPACE_EVENLY_REVERSED
    ];

    public static noWrap():WrapType
    {
        return new WrapType(WrapType.NO_WRAP);
    }

    public static start():WrapType
    {
        return new WrapType(WrapType.START);
    }

    public static end():WrapType
    {
        return new WrapType(WrapType.END);
    }

    public static center():WrapType
    {
        return new WrapType(WrapType.CENTER);
    }

    public static spaceBetween():WrapType
    {
        return new WrapType(WrapType.SPACE_BETWEEN);
    }

    public static spaceAround():WrapType
    {
        return new WrapType(WrapType.SPACE_AROUND);
    }

    public static spaceEvenly():WrapType
    {
        return new WrapType(WrapType.SPACE_EVENLY);
    }

    public static startReversed():WrapType
    {
        return new WrapType(WrapType.START_REVERSED);
    }

    public static endReversed():WrapType
    {
        return new WrapType(WrapType.END_REVERSED);
    }

    public static centerReversed():WrapType
    {
        return new WrapType(WrapType.CENTER_REVERSED);
    }

    public static spaceBetweenReversed():WrapType
    {
        return new WrapType(WrapType.SPACE_BETWEEN_REVERSED);
    }

    public static spaceAroundReversed():WrapType
    {
        return new WrapType(WrapType.SPACE_AROUND_REVERSED);
    }

    public static spaceEvenlyReversed():WrapType
    {
        return new WrapType(WrapType.SPACE_EVENLY_REVERSED);
    }

    public static isNoWrap(type:WrapType):boolean
    {
        return WrapType.noWrap().isEqualTo(type);
    }

    public static isStart(type:WrapType):boolean
    {
        return WrapType.start().isEqualTo(type);
    }

    public static isEnd(type:WrapType):boolean
    {
        return WrapType.end().isEqualTo(type);
    }

    public static isCenter(type:WrapType):boolean
    {
        return WrapType.center().isEqualTo(type);
    }

    public static isSpaceBetween(type:WrapType):boolean
    {
        return WrapType.spaceBetween().isEqualTo(type);
    }

    public static isSpaceAround(type:WrapType):boolean
    {
        return WrapType.spaceAround().isEqualTo(type);
    }

    public static isSpaceEvenly(type:WrapType):boolean
    {
        return WrapType.spaceEvenly().isEqualTo(type);
    }

    public static isStartReversed(type:WrapType):boolean
    {
        return WrapType.startReversed().isEqualTo(type);
    }

    public static isEndReversed(type:WrapType):boolean
    {
        return WrapType.endReversed().isEqualTo(type);
    }

    public static isCenterReversed(type:WrapType):boolean
    {
        return WrapType.centerReversed().isEqualTo(type);
    }

    public static isSpaceBetweenReversed(type:WrapType):boolean
    {
        return WrapType.spaceBetweenReversed().isEqualTo(type);
    }

    public static isSpaceAroundReversed(type:WrapType):boolean
    {
        return WrapType.spaceAroundReversed().isEqualTo(type);
    }

    public static isSpaceEvenlyReversed(type:WrapType):boolean
    {
        return WrapType.spaceEvenlyReversed().isEqualTo(type);
    }

    public static fromString(value:string):WrapType
    {
        return new WrapType(AString.fromString(value));
    }
}
